/**
 * Ory APIs
 *
 * Contact: support@ory.sh
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { BatchCheckPermissionBody } from '../model/batchCheckPermissionBody';
// @ts-ignore
import { BatchCheckPermissionResult } from '../model/batchCheckPermissionResult';
// @ts-ignore
import { CheckPermissionResult } from '../model/checkPermissionResult';
// @ts-ignore
import { ErrorGeneric } from '../model/errorGeneric';
// @ts-ignore
import { ExpandedPermissionTree } from '../model/expandedPermissionTree';
// @ts-ignore
import { PostCheckPermissionBody } from '../model/postCheckPermissionBody';
// @ts-ignore
import { PostCheckPermissionOrErrorBody } from '../model/postCheckPermissionOrErrorBody';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { OryConfiguration } from '../configuration';

@Injectable({
  providedIn: 'root',
})
export class PermissionService {
  protected basePath = 'http://localhost:4433';
  public defaultHeaders = new HttpHeaders();
  public configuration = new OryConfiguration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: OryConfiguration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach((elem) => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          (k) => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * Batch check permissions
   * To learn how relationship tuples and the check works, head over to [the documentation](https://www.ory.sh/docs/keto/concepts/api-overview).
   * @param maxDepth
   * @param batchCheckPermissionBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public batchCheckPermission(
    maxDepth?: number,
    batchCheckPermissionBody?: BatchCheckPermissionBody,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<BatchCheckPermissionResult>;
  public batchCheckPermission(
    maxDepth?: number,
    batchCheckPermissionBody?: BatchCheckPermissionBody,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<BatchCheckPermissionResult>>;
  public batchCheckPermission(
    maxDepth?: number,
    batchCheckPermissionBody?: BatchCheckPermissionBody,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<BatchCheckPermissionResult>>;
  public batchCheckPermission(
    maxDepth?: number,
    batchCheckPermissionBody?: BatchCheckPermissionBody,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (maxDepth !== undefined && maxDepth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxDepth, 'max-depth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (oryAccessToken) required
    localVarCredential = this.configuration.lookupCredential('oryAccessToken');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/relation-tuples/batch/check`;
    return this.httpClient.request<BatchCheckPermissionResult>(
      'post',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: batchCheckPermissionBody,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Check a permission
   * To learn how relationship tuples and the check works, head over to [the documentation](https://www.ory.sh/docs/keto/concepts/api-overview).
   * @param namespace Namespace of the Relationship
   * @param object Object of the Relationship
   * @param relation Relation of the Relationship
   * @param subjectId SubjectID of the Relationship
   * @param subjectSetNamespace Namespace of the Subject Set
   * @param subjectSetObject Object of the Subject Set
   * @param subjectSetRelation Relation of the Subject Set
   * @param maxDepth
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkPermission(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<CheckPermissionResult>;
  public checkPermission(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<CheckPermissionResult>>;
  public checkPermission(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<CheckPermissionResult>>;
  public checkPermission(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (namespace !== undefined && namespace !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>namespace, 'namespace');
    }
    if (object !== undefined && object !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>object, 'object');
    }
    if (relation !== undefined && relation !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>relation, 'relation');
    }
    if (subjectId !== undefined && subjectId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subjectId, 'subject_id');
    }
    if (subjectSetNamespace !== undefined && subjectSetNamespace !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>subjectSetNamespace,
        'subject_set.namespace'
      );
    }
    if (subjectSetObject !== undefined && subjectSetObject !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>subjectSetObject,
        'subject_set.object'
      );
    }
    if (subjectSetRelation !== undefined && subjectSetRelation !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>subjectSetRelation,
        'subject_set.relation'
      );
    }
    if (maxDepth !== undefined && maxDepth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxDepth, 'max-depth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (oryAccessToken) required
    localVarCredential = this.configuration.lookupCredential('oryAccessToken');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/relation-tuples/check/openapi`;
    return this.httpClient.request<CheckPermissionResult>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Check a permission
   * To learn how relationship tuples and the check works, head over to [the documentation](https://www.ory.sh/docs/keto/concepts/api-overview).
   * @param namespace Namespace of the Relationship
   * @param object Object of the Relationship
   * @param relation Relation of the Relationship
   * @param subjectId SubjectID of the Relationship
   * @param subjectSetNamespace Namespace of the Subject Set
   * @param subjectSetObject Object of the Subject Set
   * @param subjectSetRelation Relation of the Subject Set
   * @param maxDepth
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public checkPermissionOrError(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<CheckPermissionResult>;
  public checkPermissionOrError(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<CheckPermissionResult>>;
  public checkPermissionOrError(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<CheckPermissionResult>>;
  public checkPermissionOrError(
    namespace?: string,
    object?: string,
    relation?: string,
    subjectId?: string,
    subjectSetNamespace?: string,
    subjectSetObject?: string,
    subjectSetRelation?: string,
    maxDepth?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (namespace !== undefined && namespace !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>namespace, 'namespace');
    }
    if (object !== undefined && object !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>object, 'object');
    }
    if (relation !== undefined && relation !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>relation, 'relation');
    }
    if (subjectId !== undefined && subjectId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>subjectId, 'subject_id');
    }
    if (subjectSetNamespace !== undefined && subjectSetNamespace !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>subjectSetNamespace,
        'subject_set.namespace'
      );
    }
    if (subjectSetObject !== undefined && subjectSetObject !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>subjectSetObject,
        'subject_set.object'
      );
    }
    if (subjectSetRelation !== undefined && subjectSetRelation !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>subjectSetRelation,
        'subject_set.relation'
      );
    }
    if (maxDepth !== undefined && maxDepth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxDepth, 'max-depth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (oryAccessToken) required
    localVarCredential = this.configuration.lookupCredential('oryAccessToken');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/relation-tuples/check`;
    return this.httpClient.request<CheckPermissionResult>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Expand a Relationship into permissions.
   * Use this endpoint to expand a relationship tuple into permissions.
   * @param namespace Namespace of the Subject Set
   * @param object Object of the Subject Set
   * @param relation Relation of the Subject Set
   * @param maxDepth
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public expandPermissions(
    namespace: string,
    object: string,
    relation: string,
    maxDepth?: number,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<ExpandedPermissionTree>;
  public expandPermissions(
    namespace: string,
    object: string,
    relation: string,
    maxDepth?: number,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<ExpandedPermissionTree>>;
  public expandPermissions(
    namespace: string,
    object: string,
    relation: string,
    maxDepth?: number,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<ExpandedPermissionTree>>;
  public expandPermissions(
    namespace: string,
    object: string,
    relation: string,
    maxDepth?: number,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    if (namespace === null || namespace === undefined) {
      throw new Error('Required parameter namespace was null or undefined when calling expandPermissions.');
    }
    if (object === null || object === undefined) {
      throw new Error('Required parameter object was null or undefined when calling expandPermissions.');
    }
    if (relation === null || relation === undefined) {
      throw new Error('Required parameter relation was null or undefined when calling expandPermissions.');
    }

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (namespace !== undefined && namespace !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>namespace, 'namespace');
    }
    if (object !== undefined && object !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>object, 'object');
    }
    if (relation !== undefined && relation !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>relation, 'relation');
    }
    if (maxDepth !== undefined && maxDepth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxDepth, 'max-depth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (oryAccessToken) required
    localVarCredential = this.configuration.lookupCredential('oryAccessToken');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/relation-tuples/expand`;
    return this.httpClient.request<ExpandedPermissionTree>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Check a permission
   * To learn how relationship tuples and the check works, head over to [the documentation](https://www.ory.sh/docs/keto/concepts/api-overview).
   * @param maxDepth
   * @param postCheckPermissionBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postCheckPermission(
    maxDepth?: number,
    postCheckPermissionBody?: PostCheckPermissionBody,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<CheckPermissionResult>;
  public postCheckPermission(
    maxDepth?: number,
    postCheckPermissionBody?: PostCheckPermissionBody,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<CheckPermissionResult>>;
  public postCheckPermission(
    maxDepth?: number,
    postCheckPermissionBody?: PostCheckPermissionBody,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<CheckPermissionResult>>;
  public postCheckPermission(
    maxDepth?: number,
    postCheckPermissionBody?: PostCheckPermissionBody,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (maxDepth !== undefined && maxDepth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxDepth, 'max-depth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (oryAccessToken) required
    localVarCredential = this.configuration.lookupCredential('oryAccessToken');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/relation-tuples/check/openapi`;
    return this.httpClient.request<CheckPermissionResult>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: postCheckPermissionBody,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }

  /**
   * Check a permission
   * To learn how relationship tuples and the check works, head over to [the documentation](https://www.ory.sh/docs/keto/concepts/api-overview).
   * @param maxDepth
   * @param postCheckPermissionOrErrorBody
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postCheckPermissionOrError(
    maxDepth?: number,
    postCheckPermissionOrErrorBody?: PostCheckPermissionOrErrorBody,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<CheckPermissionResult>;
  public postCheckPermissionOrError(
    maxDepth?: number,
    postCheckPermissionOrErrorBody?: PostCheckPermissionOrErrorBody,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<CheckPermissionResult>>;
  public postCheckPermissionOrError(
    maxDepth?: number,
    postCheckPermissionOrErrorBody?: PostCheckPermissionOrErrorBody,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<CheckPermissionResult>>;
  public postCheckPermissionOrError(
    maxDepth?: number,
    postCheckPermissionOrErrorBody?: PostCheckPermissionOrErrorBody,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (maxDepth !== undefined && maxDepth !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>maxDepth, 'max-depth');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarCredential: string | undefined;
    // authentication (oryAccessToken) required
    localVarCredential = this.configuration.lookupCredential('oryAccessToken');
    if (localVarCredential) {
      localVarHeaders = localVarHeaders.set('Authorization', 'Bearer ' + localVarCredential);
    }

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['application/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/relation-tuples/check`;
    return this.httpClient.request<CheckPermissionResult>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: postCheckPermissionOrErrorBody,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress,
    });
  }
}
